import Row from '../../utils/StyledRow'

export default Row.extend`
  margin: 0;
  text-align: center;
`
